/**
 * Image Resolution Enhancement
 * Forces higher resolution images on large screens to prevent blurriness
 * Only upgrades images that are currently loading at small sizes
 */

export default class ImageResolutionEnhancement {
    constructor() {
        this.config = {
            breakpoint: 1200,
            targetWidth: 1500,
            minWidthThreshold: 600, // Only upgrade images smaller than this
            selector: '.card__media img'
        };

        this.init();
    }

    init() {
        this.upgradeImageResolution();
        
        // Run after delays to catch lazy-loaded images
        setTimeout(() => this.upgradeImageResolution(), 1000);
        setTimeout(() => this.upgradeImageResolution(), 3000);

        // Handle dynamically loaded images
        this.observeNewImages();

        // Handle resize
        window.addEventListener('resize', () => this.upgradeImageResolution());
    }

    upgradeImageResolution() {
        if (window.innerWidth < this.config.breakpoint) return;

        document.querySelectorAll(this.config.selector).forEach((img) => {
            // Skip if already processed
            if (img.dataset.upgraded) return;
            
            if (img.src && img.src.includes('&width=')) {
                // Extract current width from URL
                const widthMatch = img.src.match(/&width=(\d+)/);
                if (!widthMatch) return;
                
                const currentWidth = parseInt(widthMatch[1], 10);
                
                // Only upgrade if current width is below threshold
                if (currentWidth >= this.config.minWidthThreshold) return;
                
                const newSrc = img.src.replace(/&width=\d+/, '&width=' + this.config.targetWidth);
                
                // Mark as processed
                img.dataset.upgraded = 'true';
                
                // Clear srcset to prevent browser override
                img.srcset = '';
                
                // Preload new image before swapping
                const newImg = new Image();
                newImg.onload = () => {
                    img.src = newSrc;
                };
                newImg.src = newSrc;
            }
        });
    }

    observeNewImages() {
        const observer = new MutationObserver(() => {
            this.upgradeImageResolution();
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    }
}